import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { Label } from "arv-reactcomponents";

class RequiredField extends PureComponent {
  render() {
    const { className, children, required } = this.props;
    if (required) {
      return (
        <Label className={`nw-requiredfield ${className}`}>
          {children}
        </Label>
      );
    }

    return children;
  }
}

RequiredField.defaultProps = {
  children: "",
  className: "",
  required: false,
};

RequiredField.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  required: PropTypes.bool,
};

export default RequiredField;
